var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChipped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 371.06512,
    width: 278.02945,
    viewBox: "0 0 278.02945 371.06511",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs87"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-199.24735,-80.437761)",
    id: "g82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 283.637,80.922 c 8.216,-1.688 32.993,4.557 50.482,19.942 1.817,2.163 5.177,1.918 6.993,-0.144 47.976,-40.422 117.046,-15.213 131.244,29.949 13.794,37.204 -5.333,83.164 -9.733,96.551 -0.388,12.323 7.081,137.526 -65.766,210.42 -5.84,5.71 -11.997,12.184 -20.389,13.641 -5.191,0.086 -11.175,1.182 -15.486,-2.437 -7.786,-4.816 -9.574,-15.256 -7.022,-23.503 22.572,-68.882 -7.542,-155.006 -30.583,-106.933 -34.69,77.739 31.418,133.941 -25.911,132.845 -28.834,-7.014 -94.744,-104.817 -84.872,-224.19 -5.566,-14.362 -10.324,-29.098 -12.804,-44.339 -2.192,-4.931 2.61,-12.011 8.075,-11.362 10.843,-0.231 22.191,2.105 32.616,-1.831 17.793,-5.422 32.602,-19.985 38.398,-37.634 3.518,-8.709 2.148,-18.312 2.076,-27.454 0.157,-8.595 -9.834,-14.374 2.682,-23.521 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipped);
export default __webpack_public_path__ + "static/media/chipped.17cd35a3a0ad30576b4e6bfc6728b743.svg";
export { ForwardRef as ReactComponent };